import { appConfigDev } from './appConfigDev'
import { appConfigProd } from './appConfigProd'
import { appConfigStage } from './appConfigStage'

export const appConfig = getConfig(appConfigProd, appConfigStage, appConfigDev)

export function getConfig<TConfig>(prod: TConfig, stage: TConfig, dev: TConfig): TConfig {
  let config = prod
  const environment = getEnvironment()

  switch (environment) {
    case 'stage':
      config = stage
      break
    case 'dev':
      config = dev
      break
  }

  if (location.origin.includes('stage')) {
    config = stage
  }

  return config
}

export function getEnvironment(): 'stage' | 'prod' | 'dev' {
  return import.meta.env.VITE_NODE_ENV
}
